import React from 'react';
import PropTypes from 'prop-types';

const View = ({
  insuredRenter,
  insuredFirstName,
  insuredLastName,
  insuredCompany,
  insuredAddress,
  insuredCity,
  insuredState,
  insuredZip,
  insuredCountry,
  show,
}) =>
  show && (
    <>
      {insuredRenter && <p>{insuredCompany}</p>}
      {!insuredRenter && <p>{`${insuredFirstName} ${insuredLastName}`}</p>}
      <p>{insuredAddress}</p>
      <p>
        {`${insuredCity}, ${insuredState}, ${insuredZip}, ${insuredCountry}`}
      </p>
    </>
  );
View.propTypes = {
  insuredRenter: PropTypes.bool.isRequired,
  insuredFirstName: PropTypes.string.isRequired,
  insuredLastName: PropTypes.string.isRequired,
  insuredCompany: PropTypes.string.isRequired,
  insuredAddress: PropTypes.string.isRequired,
  insuredCity: PropTypes.string.isRequired,
  insuredState: PropTypes.string.isRequired,
  insuredZip: PropTypes.string.isRequired,
  insuredCountry: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default View;
